var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLStarFilled = function SvgLStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 29,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "m23.942 9.709-6.695-1.01-2.992-6.291a.834.834 0 0 0-1.514 0L9.75 8.7 3.054 9.709a.83.83 0 0 0-.483.254.9.9 0 0 0-.239.623.9.9 0 0 0 .255.616l4.844 4.897-1.144 6.915a.9.9 0 0 0 .05.478.87.87 0 0 0 .285.378.82.82 0 0 0 .888.066l5.988-3.265 5.988 3.265a.8.8 0 0 0 .535.087c.459-.082.767-.533.688-1.009L19.565 16.1l4.844-4.897a.9.9 0 0 0 .245-.5.87.87 0 0 0-.712-.993z"
  })));
};
export default SvgLStarFilled;